<template>
    <div class="process__content">
        <NavSecond :banner="icon_stra"></NavSecond>
        <div class="process_type animate__animated animate__fadeInUp">
            <span><i>3+1</i>专属服务团队 全程协同服务</span>
            <div class="remd">一个团队服务一个家</div>
        </div>
        <div class="wrapper__w">
            <div class="process__type--des animate__animated animate__fadeInUp">
                全程管家式服务，以客户为核心，从前期咨询到装修竣工售后服务，您将感受到隐上贴心的全方位服务。有任何问题只需联系管家一人，每个客户都拥有自己的设计团队、项目管家、管家助理、以及专业的各工班施工团队。多人分工、互相协同、互为补充，多对1超级VIP服务。
            </div>

            <el-row :gutter="30" class="process__good--ul">
                <el-col :span="8"  class="relative wow animate__fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" v-for="(item, index) in goodList" :key="index">
                    <div class="process__good--item">
                        <div><img :src="item.img"></div>
                        <div class="bd">{{item.name}}</div>
                    </div>
                    <div class="sj" v-if="index < 2">
                        <img :src="icon_s05" class="lf">
                        <img :src="icon_s05" class="lr">
                    </div>
                </el-col>
            </el-row>

            <div class="process__type--line" :style="{'background':'url('+icon_s04+')', 'background-size': '100% 100%', 'background-repeat': 'no-repeat'}">
                <div class="process_type wow animate__fadeInUp" data-wow-delay=".5s" data-wow-duration="0.8s">
                    <span>全程相伴 完整服务流程</span>
                    <div class="remd">从前期的咨询了解到竣工完成的售后， 您将感受到细致尊贵的服务</div>
                </div>
                <div class="process__line wow animate__fadeIn" data-wow-delay="0.2s" data-wow-duration="0.8s">
                    <ul>
                        <li v-for="(item, index) in iconList" :key="index">
                            <div class="box">
                                <div class="txt">{{item.tit}}</div>
                                <i class="icon wow  animate__animated ani_hei" :class="index % 2 == 0 ? 'paddHeig1' : 'paddHeig2'" data-wow-delay="0.2s" data-wow-duration="0.8s">
                                    <img :src="item.icon">
                                </i>
                            </div>
                        </li>
                    </ul>
                </div>

            </div>

            <div style="padding-top: 70px">
                <el-row :gutter="20">
                    <el-col :span="14" style="">
                        <div class="wx__left  animate__animated animate__fadeIn">
                            <img :src="wx5" class="bg">
                            <div class="phone">
                                <img :src="wx1" class="pbg">
                                <div class="phone__swiper-containers">
                                    <div class="swiper-containers">
                                        <div class="swiper-wrapper">
                                            <div class="swiper-slide"><img :src="wx2" style="width: 275px"></div>
                                            <div class="swiper-slide"><img :src="wx3" style="width: 275px"></div>
                                            <div class="swiper-slide"><img :src="wx4" style="width: 275px"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                    <el-col :span="10">
                        <div class="pro__wx--cont">
                            <div class="process_type wow animate__fadeInUp" data-wow-delay=".5s" data-wow-duration="0.8s">
                                <span>项目微信群管理</span>
                                <div class="remd">组建专属微信群各阶段群内全程跟踪</div>
                            </div>
                            <div class="pro__wx--box">
                                <div v-for="(item, index) in wxList" class="pro__wx wow animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s" :key="index">
                                    <div class="img"><img :src="item.icon" :style="item.style"></div>
                                    <div class="tit">{{item.tit}}</div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <div class="process__flow box__align" :style="{'background':'url('+icon_s06+')', 'background-size': '100% 100%', 'background-repeat': 'no-repeat'}">
                <div class="process_type wow animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s">
                    <span>客户跟踪服务</span>
                    <div class="remd">组建专属微信群各阶段群内全程跟踪</div>
                </div>
            </div>

            <div class="process__flow--line">
                <div class="flow__item wow animate__fadeInUp" data-wow-delay=".2s" data-wow-duration="0.8s" v-for="(item, index) in flowList" :key="index">
                    <div class="fl"><span>{{item.code}}</span></div>
                    <div class="fr">
                        <div class="type">{{item.type}}</div>
                        <div class="des">{{item.des}}</div>
                    </div>
                </div>
            </div>



        </div>
        <Footer></Footer>
    </div>
</template>

<script>
    import '@/assets/css/swiper.min.css'
    import Swiper, { Autoplay } from 'swiper';
    Swiper.use([Autoplay]);

    import icon_s01 from '@/assets/img/ser/s01.png'
    import icon_s02 from '@/assets/img/ser/s02.png'
    import icon_s03 from '@/assets/img/ser/s03.png'
    import icon_s04 from '@/assets/img/ser/s04.png'
    import icon_s05 from '@/assets/img/ser/s05.png'
    import icon_s06 from '@/assets/img/ser/s06.png'

    import icon_stra from '@/assets/img/gj01.png'
    import icon1 from '@/assets/img/ser/icon1.png'
    import icon2 from '@/assets/img/ser/icon2.png'
    import icon3 from '@/assets/img/ser/icon3.png'
    import icon4 from '@/assets/img/ser/icon4.png'
    import icon5 from '@/assets/img/ser/icon5.png'
    import icon6 from '@/assets/img/ser/icon6.png'
    import icon7 from '@/assets/img/ser/icon7.png'
    import icon8 from '@/assets/img/ser/icon8.png'
    import icon9 from '@/assets/img/ser/icon9.png'
    import icon10 from '@/assets/img/ser/icon10.png'
    import icon11 from '@/assets/img/ser/icon11.png'

    import w1 from '@/assets/img/ser/w1.png'
    import w2 from '@/assets/img/ser/w2.png'
    import w3 from '@/assets/img/ser/w3.png'
    import w4 from '@/assets/img/ser/w4.png'
    import w5 from '@/assets/img/ser/w5.png'
    import w6 from '@/assets/img/ser/w6.png'
    import w7 from '@/assets/img/ser/w7.png'
    import w8 from '@/assets/img/ser/w8.png'

    import wx1 from '@/assets/img/ser/wx1.png'
    import wx2 from '@/assets/img/ser/wx2.png'
    import wx3 from '@/assets/img/ser/wx3.png'
    import wx4 from '@/assets/img/ser/wx4.png'
    import wx5 from '@/assets/img/ser/wx5.png'



    import NavSecond from '@/components/NavSecond'
    import Footer from '@/layouts/Footer'


    export default {
        name: 'Test',
        data (){
            return {
                icon_stra, icon_s01, icon_s02, icon_s03, icon_s04,icon_s05,icon_s06,wx1,wx2,wx3,wx4,wx5,
                goodList: [
                    {
                        name: '业主',
                        img: icon_s01
                    },
                    {
                        name: '专属项目管家',
                        img: icon_s02
                    },
                    {
                        name: '服务团队',
                        img: icon_s03
                    }
                ],
                iconList: [
                    {
                        icon: icon1,
                        tit: '项目洽谈'
                    },
                    {
                        icon: icon2,
                        tit: '现场测量'
                    },
                    {
                        icon: icon3,
                        tit: '设计及施工方案制作'
                    },
                    {
                        icon: icon4,
                        tit: '方案三方会审(设计、施工、业主)'
                    },
                    {
                        icon: icon5,
                        tit: '项目预算制作'
                    },
                    {
                        icon: icon6,
                        tit: '合同签订'
                    },
                    {
                        icon: icon7,
                        tit: '施工管理团队启动会议'
                    },
                    {
                        icon: icon8,
                        tit: '按施工流程计划表进行有序施工'
                    },
                    {
                        icon: icon9,
                        tit: '阶段性验收'
                    },
                    {
                        icon: icon10,
                        tit: '竣工总验收及交付'
                    },
                    {
                        icon: icon11,
                        tit: '终身售后服务'
                    },

                ],
                wxList: [
                    {
                        icon: w1,
                        tit: '组建专属微信客服群日报周报定时推送 ',
                        style: 'width:35px',
                    },
                    {
                        icon: w2,
                        tit: '工程交底微信汇报',
                        style: 'width:38px',

                    },
                    {
                        icon: w3,
                        tit: '水电验收微信汇报',
                        style: 'width:30px',
                    },
                    {
                        icon: w4,
                        tit: '中期验收微信汇报',
                        style: 'width:30px',
                    },
                    {
                        icon: w5,
                        tit: '隐蔽验收微信汇报',
                        style: 'width:36px',
                    },
                    {
                        icon: w6,
                        tit: '设备安装验收微信汇报',
                        style: 'width:33px',
                    },
                    {
                        icon: w7,
                        tit: '后期产品安装进度每周微信汇报',
                        style: 'width:31px',
                    },
                    {
                        icon: w8,
                        tit: '工程竣工验收汇报',
                        style: 'width:33px',
                    },
                ],
                flowList: [
                    {
                        code: '01',
                        type: '定期回访',
                        des: '定期回访，了解项目进度及工地问题'
                    },
                    {
                        code: '04',
                        type: '售后回访',
                        des: '保修期内定期回访，了解项目交付后客户入住情况，为客户提供增值服务，保修期到期前回访，提醒客户有需求维修的及时提报'
                    },
                    {
                        code: '02',
                        type: '节点回访',
                        des: '现场交底、隐蔽验收、中期验收、竣工验收3个工作日内，了解客户的服务感受及对项目组成员的满意度'
                    },
                    {
                        code: '05',
                        type: '客诉管理',
                        des: '对客户建立客诉档案，出现客诉意见8小时跟踪解决。对公司归类常见问题，提升客诉处理的专业性和系统性'
                    },
                    {
                        code: '03',
                        type: '竣工回访',
                        des: '工程、产品全部完结，对客户进行整体完工回访，全面了解客户的服务感受及对公司的建议，办理竣工保修时，填写满意度打分表'
                    }
                ],
            }
        },
        components: {
            NavSecond,Footer
        },
        mounted() {
            this.$wow.init()
            new Swiper('.swiper-containers', {
                direction: 'vertical',
                autoplay: {
                    delay: 2500,
                },
            });
        }
    }
</script>
<style  lang="scss" scoped>
    .process__content {
        .paddHeig1{
            -webkit-animation-name: paddHeig1;
            animation-name: paddHeig1
        }
        @keyframes paddHeig1 {
            0% {

                padding-bottom: 0
            }
            100% {
                padding-bottom: 150px;
            }
        }
        .paddHeig2{
            -webkit-animation-name: paddHeig2;
            animation-name: paddHeig2
        }
        @keyframes paddHeig2 {
            0% {

                padding-bottom: 0
            }
            100% {
                padding-bottom: 60px;
            }
        }
        .ani_hei{
            -webkit-animation-duration:1s;
            animation-duration:1s;
            -webkit-animation-fill-mode:both;
            animation-fill-mode:both
        }
        .process_type {
            text-align: center;
            font-size: 36px;
            font-weight: bold;
            color: #010101;
            padding-top: 100px;
            padding-bottom: 70px;
            i{
                font-style: normal;
                color: #F55E1B;
            }
            .remd{
                font-size: 28px;
                font-weight: bold;
                color: #000000;
                margin-top: 50px;
            }
            span {
                position: relative;

                &::after {
                    content: '';
                    display: block;
                    position: absolute;
                    left: 50%;
                    margin-left: -16px;
                    bottom: -10px;
                    width: 32px;
                    height: 4px;
                    background: #F55E1B;
                }
            }

        }
        .process__type--des{
            margin:0 auto;
            width: 60%;
            text-align:center;
            font-size: 16px;
            font-weight: 400;
            color: #000000;
            line-height: 24px;
            margin-bottom: 105px;
        }
        .process__good--ul {
            position: relative;
            /*.sj__bg {*/
            /*    position: absolute;*/
            /*    z-index: 1;*/
            /*    width: 100%;*/
            /*    z-index: 1;*/
                .sj {
                    left: 0;
                    top: 0;
                    width: 100%;
                    height: 100%;
                    position: absolute;
                    z-index: 1;
                    img {
                        display: block;
                        position: absolute;
                        width: 310px;
                        height: 310px;
                        right: 0;
                        top: 50%;
                        margin-top: -180px;
                    }
                    .lf {
                        right: -30px;
                    }
                }
            /*}*/
            .process__good--item {
                font-size: 28px;
                font-weight: 400;
                color: #010101;
                line-height: 24px;
                text-align: center;
                z-index: 22;
                position: relative;
                img {
                    width: 100%;
                    display: block;
                    height: 392px;
                    object-fit: cover;
                    margin-bottom: 20px;
                }
            }
        }
        .process__type--line{
            margin-top: 120px;
            height: 500px;
            .process_type{
                opacity: .95;
                color: #fff;
                font-size: 37px;
                padding-top: 80px;
                padding-bottom: 30px;
                .remd{
                    font-size: 16px;
                    color: #fff;
                    font-weight: 400;
                }
            }

        }
        .process__line{
            margin-top: 20px;
            ul {
                overflow: hidden;
                li {
                    float: left;
                    width: 9.09%;
                    text-align: center;
                    height: 260px;
                    position: relative
                }
                .box{
                    width: 100%;
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    -webkit-transform: translateX(-50%);
                    transform: translateX(-50%);
                    .txt{
                        color: #fff;
                        position: relative;
                        top: -10px;
                        font-size: 14px;
                        font-weight: 400;
                        opacity: .8;
                    }
                    .icon{
                        display: inline-block;
                        font-size: 0;
                        position: relative;
                        z-index: 1;
                        img{
                            width: 60px;
                            height: 60px;
                        }
                    }
                    .icon:after{
                        content: "";
                        width: 1px;
                        height: 100%;
                        position: absolute;
                        top: 0;
                        left: 50%;
                        -webkit-transform: translateX(-50%);
                        transform: translateX(-50%);
                        background-color: #fff;
                        opacity: .8;
                        z-index: -1;
                    }
                }

            }
        }
        .pro__wx--cont {
            .remd{
                font-size: 16px;
                color: #010101;
                font-weight: 400;
            }
            .pro__wx--box {
                text-align: center;
                overflow: hidden;
                padding: 0 12%;

                .pro__wx {
                    width: 50%;
                    float: left;
                    font-size: 16px;
                    font-weight: 400;
                    color: #010101;
                    line-height: 24px;
                    height: 100px;
                    margin-bottom: 20px;
                    .img{
                        height: 41px;
                    }
                }
            }
        }
        .process__flow{
            height: 400px;
            margin-top: 220px;
            .process_type{
                text-align: left;
                color: #fff;
                margin-left: 10%;
                .remd{
                    color: #fff;
                    width: 256px;
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 24px;
                }
            }
        }
        .process__flow--line{
            padding-top: 80px;
            padding-bottom: 100px;
            overflow: hidden;
            .flow__item{
                margin-right: 3%;
                width: 48.5%;
                float: left;
                overflow: hidden;
                height: 150px;
                .fl{
                    height: 100%;
                    span{
                        width: 100px;
                        font-size: 72px;
                        font-weight: bold;
                        color: #F1F1F1;
                    }
                }
                .fr{
                    width: calc(100% - 100px);
                    margin-top: 15px;
                }
                .type{
                    font-size: 28px;
                    font-weight: 400;
                    color: #EA5413;
                    line-height: 24px;
                    margin-bottom: 20px;
                }
                .des{
                    font-size: 16px;
                    font-weight: 400;
                    color: #010101;
                    line-height: 24px;
                }
            }
            .flow__item:nth-child(2n){
                margin-right: 0;
            }
        }
        .wx__left{
            margin-top: 100px;
            width: 710px;
            position: relative;
            .bg{
                height: 660px;
                display: block;
            }
            .phone{
                position: absolute;
                right: 100px;
                top: 100px;
                .pbg{
                    width: 331px;
                    height: 652px;
                }
            }
            .phone__swiper-containers{
                position: absolute;
                left: 28px;
                top: 60px;
                .swiper-containers{
                    width: 275px;
                    height: 526px;
                    overflow: hidden;
                    .swiper-slide{
                        height: 526px;
                    }
                    img{
                        width: 275px;
                        height: 526px;
                    }
                }
            }
        }
    }
</style>
